enum TagContainer {
  Media = '1',
  Analytics = '7',
}

export type TrackingFunctionName = 'tc_events_1' | 'tc_events_7';

export default TagContainer;
